import styles from '../styles/PCButton.module.scss';

interface ButtonProps {
    label: string;
    color: string;
    shadowColor: string;
    onClick: () => void;
}

const PCButton: React.FC<ButtonProps> = ({ label,color, shadowColor, onClick }) =>  {


    return (
        <div className={styles.Button} onClick={onClick} style={{backgroundColor: color, boxShadow: '-4px 4px '+shadowColor}}>
            {label}
        </div>
    );
}

export default PCButton;
